export const LINK_PATTERN =
  /\b(?:https?|ftp):\/\/[-a-zA-Z0-9+&@#\\/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]/;
